import React, { PropsWithChildren } from 'react';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import bem from '../../../lib/bemUtils/bem';

export enum TileGridModifier {
  TWO_COLUMNS_MAX = 'two-columns-max',
  FOUR_COLUMNS_MAX = 'four-columns-max',
  ROW_GAP_LARGE = 'row-gap-large',
}

type TileGridProps = {
  modifier?: Modifier<TileGridModifier>;
} & PropsWithChildren;

export function TileGrid({ children, modifier }: TileGridProps) {
  return <ol className={bem('tiles__grid', modifier)}>{children}</ol>;
}
